import * as React from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Rating } from "@mui/material";
import { useTranslation } from "react-i18next";

const SummaryTable = ({
  data,
  totalRowCount,
  pageNumber,
  setPageNumber,
  pageSize,
  setPageSize,
  handleButton,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      field: "actions",
      type: "actions",
      getActions: (params) => [
        <Button onClick={() => handleButton(params)}>Edit</Button>,
      ],
      width: 100,
    },
    { field: "name", headerName: t("product-name"), width: 300 },
    { field: "author", headerName: t("author"), width: 150 },
    { field: "category", headerName: t("category"), width: 130 },
    {
      field: "score",
      headerName: t("score"),
      width: 150,
      renderCell: (params) => (
        <Rating value={params.value} precision={0.5} readOnly />
      ),
    },
    { field: "updateDate", headerName: t("update-date"), width: 130 },
  ];

  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCountState` from being undefined during the loading
  const [rowCountState, setRowCountState] = React.useState(totalRowCount || 0);

  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      totalRowCount !== undefined ? totalRowCount : prevRowCountState
    );
  }, [totalRowCount, setRowCountState]);

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        autoHeight
        rows={data}
        columns={columns}
        rowsPerPageOptions={[25, 50, 100]}
        rowCount={rowCountState}
        page={pageNumber}
        onPageChange={setPageNumber}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        pagination
        paginationMode="server"
        loading={false}
      />
    </Box>
  );
};

SummaryTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      author: PropTypes.string,
      category: PropTypes.string.isRequired,
    })
  ).isRequired,
  totalRowCount: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageSize: PropTypes.func.isRequired,
  handleButton: PropTypes.func.isRequired,
};

export default SummaryTable;
